import React from 'react';
import Box from '@mui/material/Box';
import { StaticImage } from 'gatsby-plugin-image';
import { i18n_article_spam_just_isnt_yogic } from '@yi/i18n/phrases/i18n_article_spam_just_isnt_yogic';
import { i18n_have_an_account } from '@yi/i18n/phrases/i18n_have_an_account';
import { i18n_sign_in } from '@yi/i18n/phrases/i18n_sign_in';
import { i18n_trial_for_new_users_only } from '@yi/i18n/phrases/i18n_trial_for_new_users_only';

import {
  BottomLeftText,
  BottomRightLinkText,
  MembershipText,
  ModalContentWrapper,
  ModalFooter,
  P,
} from './elements';
import { PaywallSetEmailForm } from './PaywallSetEmailForm';
import { useLocale } from '../../../../LocaleProvider';

const defaultRenderImage = () => (
  <StaticImage
    src={'../../../../../images/dashboard-devices.png'}
    placeholder="blurred"
    alt="devices"
    loading="eager"
    style={{ maxWidth: '65%', height: 'auto' }}
    objectPosition="75% 0%"
  />
);

interface Props {
  onClickSignIn?(): void;
  heading: React.ReactNode;
  subHeading: React.ReactNode;
  renderImage?: () => React.ReactNode;
  returnUrl: string;
}

export const AnonymousPaywall: React.FC<Props> = ({
  heading,
  subHeading,
  onClickSignIn,
  renderImage = defaultRenderImage,
  returnUrl,
}) => {
  const { locale } = useLocale();
  return (
    <div data-testid="anonymous-modal-paywall">
      <ModalContentWrapper>
        <Box p={2}>
          <MembershipText>{heading}</MembershipText>
          <p>{subHeading}</p>
          {renderImage()}
          <PaywallSetEmailForm returnUrl={returnUrl} />
          <input type="hidden" name="registration_type" value="classes_paywall" />
          <input type="hidden" name="language" value="English" />
          <P>
            {i18n_article_spam_just_isnt_yogic(locale)}
            <br />
            {i18n_trial_for_new_users_only(locale)}
          </P>
        </Box>
        <ModalFooter>
          <BottomLeftText>{i18n_have_an_account(locale)}</BottomLeftText>
          <BottomRightLinkText
            data-testid="sign-in-button"
            href="javascript:void(0);"
            onClick={onClickSignIn}
          >
            {i18n_sign_in(locale)}
          </BottomRightLinkText>
        </ModalFooter>
      </ModalContentWrapper>
    </div>
  );
};
